import { Injectable } from "@angular/core";
import { getAuth, User, Auth } from "firebase/auth";

@Injectable({
  providedIn: "root",
})
export class FirebaseService {
  /**
   * Get Firebase Auth
   * @returns {Auth} auth object
   */
  #getAuth(): Auth {
    const auth = getAuth();
    return auth;
  }

  async signOut(): Promise<void> {
    await this.#getAuth().signOut();
  }

  /**
   * Get the current user
   * @returns
   */
  async getUser(): Promise<User | null> {
    return new Promise((resolve) => {
      this.#getAuth().onAuthStateChanged((user: User | null) => {
        resolve(user);
      });
    });
  }

  /**
   * Get the current user
   * @returns
   */
  async getToken(): Promise<string | null> {
    return new Promise((resolve) => {
      const auth = getAuth();
      auth.onAuthStateChanged(async (user) => {
        if (user != null) {
          const token = await user?.getIdToken();
          resolve(token);
        }
        resolve(null);
      });
    });
  }

  /**
   * Checks if the firebase User prop is defined
   * @returns true if logged in
   */
  async isLoggedIn(): Promise<boolean> {
    return new Promise((resolve) => {
      const auth = getAuth();
      auth.onAuthStateChanged((user) => {
        if (user != null) {
          resolve(true);
        }
        resolve(false);
      });
    });
  }
}
